export interface Outcome {
  title: string
  description: string
}

export const outcomes: Outcome[] = [
  {
    title: '⚡ Stop Planning Everything From Scratch',
    description: 'Use ready-made professional resources instead.',
  },
  {
    title: '⛳ Know What to Coach Next',
    description: 'Connect player problems with drills, sessions, and practice.',
  },
  {
    title: '📋 Keep Everything Organized',
    description: 'Assessment, coaching, practice, and progress in one system.',
  },
  {
    title: '🚀 Spend Less Time Preparing',
    description: 'And more time actually coaching.',
  },
]
